import { gql } from '@apollo/client'

// query name added, will appear as getAsset in asset manager
export default gql(`
query getVirtualAsset($id: ID! $project: String $module: String) {
    getAsset(
        id: $id
        project: $project
        module: $module
    ) {
        id
        shortId
        externalId
        type
        title
        shortTitle
        description
        duration
        shortDescription
        updatedAt
        updatedBy   
        duration
        externalId
        type
        title
    }
}`)
